/**
 * User Slice for redux
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 11/03/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      11/03/2025    Akhil Soman     Creating new File
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  userDetails: any; // Replace `any` with a proper interface for user details
}

const initialState: UserState = {
  userDetails: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails(state, action: PayloadAction<any>) {
      state.userDetails = action.payload;
    },
    clearUserDetails(state) {
      state.userDetails = null;
    },
  },
});

export const { setUserDetails, clearUserDetails } = userSlice.actions;
export default userSlice.reducer;
